import { Statsig, StatsigUser, useExperiment } from 'statsig-react';

import { store } from '../../store';
import { get } from 'lodash';
import { isMobileDevice } from '../library';

interface ConfigResult {
  [key: string]: any;
  isLoading: boolean;
}

type DefaultValues = { [key: string]: any };

/* Updates Statsig user properties */
export const updateStatsigUser = () => {
  const reduxStore = store.getState();

  const userSession = get(reduxStore, 'rootReducer.userSessionReducer.user_session', {});
  if (userSession.customer_id) {
    const statsigUserProperties: StatsigUser = {
      userID: userSession.customer_id,
      country: userSession.country_code,
      email: userSession.email,
      custom: {
        isAmazeCustomer: userSession?.is_amaze_customer,
        deviceType: isMobileDevice() ? 'Mobile_Web' : 'Web'
      }
    };

    Statsig.updateUser(statsigUserProperties);
  }
};

/* Clears current statsig user context */
export const resetStatsigUser = () => {
  Statsig.updateUser(null);
};

/* Used for A/B/n testing */
export const useExperimentConfig = (
  experimentName: string,
  parameterNames: string[],
  defaultValues: DefaultValues = {}
): ConfigResult => {
  const { config, isLoading } = useExperiment(experimentName);
  const result: { [key: string]: any } = {};

  for (const parameterName of parameterNames) {
    result[parameterName] = config.get(parameterName, defaultValues[parameterName] ?? null);
  }

  return { ...result, isLoading };
};

/**  Use case for using A/B testing hook **
 * 
const { value1, value2, isLoading } = useExperimentConfig(
    'myExperiment', 
    ['param1', 'param2'],
    {
        param1: 'default1',
        param2: 42
    }
);
*/

/*
  Fetching flags
  const {value, isLoading} = useGate(gateName);
*/

/* 
 Logs an event to Statsig.
 eventValue and metaData is optional

 Statsig.logEvent(eventName, eventValue, metaData);
*/
